// extracted by mini-css-extract-plugin
module.exports = {"hero-list":"WebtraderHero_hero-list__q22W_","title":"WebtraderHero_title__ureoB","red_box_text":"WebtraderHero_red_box_text__qH_6v"};